import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpEvent, HttpHeaders } from '@angular/common/http';
import { EnvironmentService } from '../core/environment/environment.service';

import { ComboboxStatus } from './model/combobox-status.model';
import { BrokerageFeePaginationParameters } from './model/brokerage-fee-pagination-parameters.model';
import { Observable, throwError } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
import { AuthUser } from '@app/core/auth/auth-frame/auth-user.model';
import { AuthService } from '@app/core/auth/auth.service';
import { SessionService } from '@app/core/session/session.service';

@Injectable({
    providedIn: 'root'
})
export class BrokerageFeeService {

    public currentGestorDemanda: string = null;
    private serviceUrl: string = '/brokeragefee';
    private apiUrl: string;
    private jwt: string = this.sessionService.retrieveToken();
    authUser: AuthUser;
    authSubject: Observable<AuthUser>;
    statusRquest: boolean = true;

    constructor(
        private http: HttpClient,
        private environmentService: EnvironmentService,
        private authService: AuthService,
        private sessionService: SessionService,
    ) {
        this.apiUrl = this.environmentService.envModel.appSettings.apiUrlBrokerageFee;
        this.authSubject = this.authService.getAuthModel();
        this.authSubject.subscribe((user: AuthUser) => {
            this.authUser = user;
        });
    }

    updateBrokerageFeeList(applyList: Array<any>, parameters: BrokerageFeePaginationParameters): Observable<any> {

        var ret;
        var endpointPagination = '/taxas_corretagem';
        var url  = `${this.apiUrl}${this.serviceUrl}${endpointPagination}`
        //url = 'http://localhost:14609/IS/api/brokeragefee-service/brokeragefee/taxas_corretagem';
        var bodyObj = JSON.stringify(applyList);
        ret = this.http.post<any>(url, bodyObj,
            {
                headers: new HttpHeaders()
                    .set('Content-Type', 'application/json')
                    .set('Access-Control-Allow-Headers', 'x-jwt')
                    .set("x-jwt", parameters.jwt.trim()),

                observe: 'response' as 'response'
            }
        )
        return ret;
    }

    //Chamada de serviço do back end para preenchimento de grid
    //api/brokeragefee-service/brokeragefee/taxas_corretagem_boletas
    getBrokerageFeeList(parameters: BrokerageFeePaginationParameters) {

        if (parameters !== undefined) {
            var url: string;
            var queryParams: string = '';
            var endpointPagination = '/taxas_corretagem_boletas?';
            var ret;

            queryParams += 'page=' + (parameters.pageIndex.toString());
            queryParams += '&page_size=' + (parameters.pageSize.toString());
            queryParams += '&carteira=' + encodeURIComponent(parameters.carteira.toString().trim().length === 0 ? '' : parameters.carteira.toString());
            queryParams += '&data_inicio_negociacao=' + encodeURIComponent(parameters.data_inicio_negociacao === null ? '' : parameters.data_inicio_negociacao.toLocaleString('pt-BR'));
            queryParams += '&data_fim_negociacao=' + encodeURIComponent(parameters.data_fim_negociacao === null ? '' :parameters.data_fim_negociacao.toLocaleString('pt-BR'));
            queryParams += '&modalidade=' + encodeURIComponent(parameters.modalidade.length === 0 ? '' : parameters.modalidade.join(','));
            queryParams += '&corretora=' + encodeURIComponent(parameters.corretora.toString().trim().length === 0 ? '' : parameters.corretora.toString());
            queryParams += '&papel=' + encodeURIComponent(parameters.papel.toString().trim().length === 0 ? '' : parameters.papel.toString());
            queryParams += '&status=' + encodeURIComponent(parameters.status.length === 0 ? '' : parameters.status.join(','));

            url = `${this.apiUrl}${this.serviceUrl}${endpointPagination}${queryParams}`;
            //url = 'http://localhost:14609/IS/api/brokeragefee-service/brokeragefee' + `${endpointPagination}${queryParams}`

            ret = this.http.get<any[]>(url,
                {
                    headers: new HttpHeaders()
                        .set("x-jwt", parameters.jwt.trim())
                        .set('Content-Type', 'application/json'),
                    observe: 'response' as 'response'
                }
            );

            return ret;
        }
    }

    //Chamada de serviço do Back end para export Excel e PDF
    //api/brokeragefee-service/brokeragefee/taxas_corretagem/binario
    getBrokerageFeeExport(parameters: BrokerageFeePaginationParameters) {
        if (parameters !== undefined) {
            var url = ''
            var queryParams: string = '';
            var endpointPagination = '/taxas_corretagem/binario?';
            var ret;

            queryParams += 'carteira=' + encodeURIComponent(parameters.carteira.toString().trim().length === 0 ? '' : parameters.carteira.toString());
            queryParams += '&data_inicio_negociacao=' + encodeURIComponent(parameters.data_inicio_negociacao === null ? '' : parameters.data_inicio_negociacao.toLocaleString('pt-BR'));
            queryParams += '&data_fim_negociacao=' + encodeURIComponent(parameters.data_fim_negociacao === null ? '' :parameters.data_fim_negociacao.toLocaleString('pt-BR'));
            queryParams += '&modalidade=' + encodeURIComponent(parameters.modalidade.length === 0 ? '' : parameters.modalidade.join(','));
            queryParams += '&corretora=' + encodeURIComponent(parameters.corretora.toString().trim().length === 0 ? '' : parameters.corretora.toString());
            queryParams += '&papel=' + encodeURIComponent(parameters.papel.toString().trim().length === 0 ? '' : parameters.papel.toString());
            queryParams += '&status=' + encodeURIComponent(parameters.status.length === 0 ? '' : parameters.status.join(','));

            url = `${this.apiUrl}${this.serviceUrl}${endpointPagination}${queryParams}`;
            //url = 'http://localhost:14609/IS/api/brokeragefee-service/brokeragefee' + `${endpointPagination}${queryParams}`

            ret = this.http.get<any[]>(url,
                {
                    headers: new HttpHeaders()
                        .set('Content-Type', 'application/json')
                        .set("x-jwt", parameters.jwt.trim()),
                    observe: 'response' as 'response'
                }
            );

            return ret;
        }//[]
    }

    //Chamada de serviço do back end para preenchimento de combo box
    //api/brokeragefee-service/brokeragefee/Status
    getStatus(parameters: BrokerageFeePaginationParameters) {
        var endpointPagination = '/status_taxas_corretagem';
        var newToken: string;
        var url = `${this.apiUrl}${this.serviceUrl}${endpointPagination}` + '?ativo=true';
        //url = 'http://localhost:14609/IS/api/brokeragefee-service/brokeragefee/status_taxas_corretagem?ativo=true';

        return this.http.get<any[]>(url,
            {
                headers: new HttpHeaders()
                    .set("x-jwt", parameters.jwt.trim())
                    .set('Content-Type', 'application/json')
                ,
                observe: 'response' as 'response'
            }
        );
    }

    getWorkTime(parameters: BrokerageFeePaginationParameters) {

        var endpointPagination = '/taxas_corretagem/horario_limite';
        var newToken: string;
        var url = `${this.apiUrl}${this.serviceUrl}${endpointPagination}`;
        //url = 'http://localhost:14609/IS/api/brokeragefee-service/brokeragefee/taxas_corretagem/horario_limite';

        return this.http.get<any[]>(url,
            {
                headers: new HttpHeaders()
                    .set('Content-Type', 'application/json')
                    .set("x-jwt", parameters.jwt.trim())
                ,
                observe: 'response' as 'response'
            }
        );
    }

    //Repassa o resultado para um array
    jsonDataToComboboxStatuss(jsonData: any[]): ComboboxStatus[] {
        const items: ComboboxStatus[] = [];
        if (jsonData && Array.isArray(jsonData)) {
            jsonData.forEach(element =>
              {
                let el = element as ComboboxStatus
                el.nome_status_taxa_corretagem= this.ChangeLang(el.codigo_status_taxa_corretagem);
               items.push(el as ComboboxStatus)
              });
        }
        return items;
    }

    public ChangeLang(cod : number|any) : string
    {
      let lang = localStorage.getItem('lang') === 'br' ? 'pt-BR' : 'en-US';
      let retorno = '';
      switch(cod)
      {
        case 1: {
          if (lang === 'pt-BR'){
            retorno='Aprovado';
          } else {
            retorno='Approved';
          }
          break;
        }
        case 2: {
          if (lang === 'pt-BR'){
            retorno='Reprovado';
          } else {
            retorno='Reproved';
          }
          break;
        }
        case 3:{
          if (lang === 'pt-BR'){
            retorno='Inconsitente';
          } else {
            retorno='Unmatched';
          }
          break;
        }
        case 5:{
          if (lang === 'pt-BR'){
            retorno='Consistente';
          } else {
            retorno='Matched';
          }
          break;
        }
        default:{
            retorno= '';
            break;
        }

      }
      return retorno;
    }

    //Repassa o Access Token
    public setToken(newToken: string) {
        if (newToken && newToken != '') {
            this.jwt = newToken;
            this.sessionService.setToken(newToken);
        }
    }

    private handleError(error: HttpErrorResponse) {
        this.statusRquest = false;
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(
            'Erro ao enviar demanda.');
    }
}
